import { render } from "./ErrorView.vue?vue&type=template&id=3f3836d4"
import script from "./ErrorView.vue?vue&type=script&lang=js"
export * from "./ErrorView.vue?vue&type=script&lang=js"

import "./ErrorView.vue?vue&type=style&index=0&id=3f3836d4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__